<template>
  <div id="printable" class="register-container">
    <!-- Header -->
    <div class="header">
      <div class="facility-name">
        TUURU COTTOLENGO HEALTH CENTRE - AR2026259
      </div>
      <div class="facility-details">
        <div>Igembe Central</div>
        <div>P.O BOX 77 - Meru | Tel: 254254746758069</div>
        <div>Email: suore.tuuru@cottolengo.org</div>
      </div>
      <div class="register-title">MOH 335 - LABORATORY REGISTER</div>
    </div>

    <!-- Date Range and Generated By Bar -->
    <div class="info-bar">
      <div class="info-left">
        <div class="date-range">
          <div class="info-item">
            <span class="info-label">From:</span>
            <input
              type="date"
              v-model="dateFrom"
              class="date-input"
              @change="filterRecords"
            />
          </div>
          <div class="info-item">
            <span class="info-label">To:</span>
            <input
              type="date"
              v-model="dateTo"
              class="date-input"
              @change="filterRecords"
            />
          </div>
          <button @click="clearDates" class="btn-clear">Clear</button>
        </div>
        <div class="info-item">
          <span class="info-label">Generated By:</span>
          <span class="info-value">{{ generatedBy }}</span>
        </div>
      </div>
      <button @click="printPage" class="btn-print">Print Register</button>
    </div>

    <!-- Date Range Display for Print -->
    <div class="print-date-range">
      <strong>Report Period:</strong> {{ formattedDateFrom }} to
      {{ formattedDateTo }}
    </div>

    <!-- Summary Statistics -->
    <div class="summary-stats">
      <div class="stat-box">
        <span class="stat-label">Total Tests</span>
        <span class="stat-number">{{ totalTests }}</span>
      </div>
      <div class="stat-box">
        <span class="stat-label">Malaria Tests</span>
        <span class="stat-number">{{ malariaTests }}</span>
      </div>
      <div class="stat-box">
        <span class="stat-label">HIV Tests</span>
        <span class="stat-number">{{ hivTests }}</span>
      </div>
      <div class="stat-box">
        <span class="stat-label">Positive Results</span>
        <span class="stat-number">{{ positiveResults }}</span>
      </div>
    </div>

    <!-- Table -->
    <div class="table-wrapper">
      <table class="lab-table">
        <thead>
          <tr>
            <th>#</th>
            <th>Date</th>
            <th>Lab No</th>
            <th>Full Names</th>
            <th>Age</th>
            <th>Sex</th>
            <th>Contact</th>
            <th>SubLocation</th>
            <th>Test Requested</th>
            <th>Specimen Type</th>
            <th>Test Result</th>
            <th>Referred To</th>
            <th>Technician</th>
            <th>Date Reported</th>
            <th>Remarks</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(record, index) in filteredRecords" :key="index">
            <td>{{ index + 1 }}</td>
            <td>{{ record.date }}</td>
            <td>{{ record.labNo }}</td>
            <td>{{ record.fullNames }}</td>
            <td>{{ record.age }}</td>
            <td class="text-center">{{ record.sex }}</td>
            <td>{{ record.contact }}</td>
            <td>{{ record.subLocation }}</td>
            <td>{{ record.testRequested }}</td>
            <td>{{ record.specimen }}</td>
            <td class="text-center">
              <span :class="getResultClass(record.result)">
                {{ record.result }}
              </span>
            </td>
            <td>{{ record.referredTo }}</td>
            <td>{{ record.technician }}</td>
            <td>{{ record.dateReported }}</td>
            <td>{{ record.remarks }}</td>
          </tr>
          <tr v-if="filteredRecords.length === 0">
            <td colspan="15" class="empty-row">
              No laboratory records found for the selected date range
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: "MOH335Laboratory",
  data() {
    return {
      dateFrom: "2026-04-01",
      dateTo: "2026-04-30",
      generatedBy: "SR. JANE KAREGI MUNYUGI",
      labRecords: [
        {
          date: "2026-04-22",
          labNo: "LAB001",
          fullNames: "John Mwenda",
          age: 32,
          sex: "M",
          contact: "0712345678",
          subLocation: "Kianjai",
          testRequested: "Malaria RDT",
          specimen: "Blood",
          result: "Positive",
          referredTo: "OPD",
          technician: "P. Muthoni",
          dateReported: "2026-04-22",
          remarks: "P. falciparum",
        },
        {
          date: "2026-04-22",
          labNo: "LAB002",
          fullNames: "Mary Wanjiku",
          age: 28,
          sex: "F",
          contact: "0723456789",
          subLocation: "Mutuati",
          testRequested: "Urinalysis",
          specimen: "Urine",
          result: "UTI",
          referredTo: "OPD",
          technician: "J. Karani",
          dateReported: "2026-04-22",
          remarks: "Nitrites positive",
        },
        {
          date: "2026-04-21",
          labNo: "LAB003",
          fullNames: "Peter Kimathi",
          age: 45,
          sex: "M",
          contact: "0734567890",
          subLocation: "Kangeta",
          testRequested: "HIV Rapid Test",
          specimen: "Blood",
          result: "Negative",
          referredTo: "HTS",
          technician: "P. Muthoni",
          dateReported: "2026-04-21",
          remarks: "Post-test counselling done",
        },
        {
          date: "2026-04-21",
          labNo: "LAB004",
          fullNames: "Grace Muthoni",
          age: 35,
          sex: "F",
          contact: "0745678901",
          subLocation: "Laare",
          testRequested: "Blood Glucose",
          specimen: "Blood",
          result: "8.2 mmol/L",
          referredTo: "Chronic Care",
          technician: "J. Karani",
          dateReported: "2026-04-21",
          remarks: "Fasting glucose high",
        },
        {
          date: "2026-04-20",
          labNo: "LAB005",
          fullNames: "James Mwirigi",
          age: 52,
          sex: "M",
          contact: "0756789012",
          subLocation: "Kianjai",
          testRequested: "Malaria RDT",
          specimen: "Blood",
          result: "Negative",
          referredTo: "OPD",
          technician: "P. Muthoni",
          dateReported: "2026-04-20",
          remarks: "Rule out other causes",
        },
        {
          date: "2026-04-20",
          labNo: "LAB006",
          fullNames: "Lucy Mwende",
          age: 29,
          sex: "F",
          contact: "0767890123",
          subLocation: "Mutuati",
          testRequested: "Pregnancy Test",
          specimen: "Urine",
          result: "Positive",
          referredTo: "ANC",
          technician: "J. Karani",
          dateReported: "2026-04-20",
          remarks: "Referred to ANC clinic",
        },
        {
          date: "2026-04-19",
          labNo: "LAB007",
          fullNames: "Esther Kendi",
          age: 41,
          sex: "F",
          contact: "0778901234",
          subLocation: "Kangeta",
          testRequested: "Hb Level",
          specimen: "Blood",
          result: "9.5 g/dL",
          referredTo: "OPD",
          technician: "P. Muthoni",
          dateReported: "2026-04-19",
          remarks: "Anaemia",
        },
        {
          date: "2026-04-19",
          labNo: "LAB008",
          fullNames: "Samuel Mutuma",
          age: 8,
          sex: "M",
          contact: "0789012345",
          subLocation: "Laare",
          testRequested: "Malaria RDT",
          specimen: "Blood",
          result: "Positive",
          referredTo: "Pediatrics",
          technician: "J. Karani",
          dateReported: "2026-04-19",
          remarks: "Severe malaria",
        },
        {
          date: "2026-04-18",
          labNo: "LAB009",
          fullNames: "Naomi Gacheri",
          age: 33,
          sex: "F",
          contact: "0790123456",
          subLocation: "Kianjai",
          testRequested: "HIV Rapid Test",
          specimen: "Blood",
          result: "Positive",
          referredTo: "ART Clinic",
          technician: "P. Muthoni",
          dateReported: "2026-04-18",
          remarks: "Linked to ART care",
        },
        {
          date: "2026-04-18",
          labNo: "LAB010",
          fullNames: "Mercy Kajuju",
          age: 22,
          sex: "F",
          contact: "0701234567",
          subLocation: "Mutuati",
          testRequested: "Urinalysis",
          specimen: "Urine",
          result: "Normal",
          referredTo: "OPD",
          technician: "J. Karani",
          dateReported: "2026-04-18",
          remarks: "All parameters normal",
        },
        {
          date: "2026-04-17",
          labNo: "LAB011",
          fullNames: "Daniel Mwiti",
          age: 38,
          sex: "M",
          contact: "0712345670",
          subLocation: "Kangeta",
          testRequested: "Blood Glucose",
          specimen: "Blood",
          result: "6.5 mmol/L",
          referredTo: "Chronic Care",
          technician: "P. Muthoni",
          dateReported: "2026-04-17",
          remarks: "Impaired fasting glucose",
        },
        {
          date: "2026-04-17",
          labNo: "LAB012",
          fullNames: "Ruth Nkirote",
          age: 26,
          sex: "F",
          contact: "0723456780",
          subLocation: "Laare",
          testRequested: "Syphilis RPR",
          specimen: "Blood",
          result: "Non-reactive",
          referredTo: "ANC",
          technician: "J. Karani",
          dateReported: "2026-04-17",
          remarks: "ANC screening",
        },
      ],
    };
  },
  computed: {
    formattedDateFrom() {
      return this.dateFrom
        ? new Date(this.dateFrom).toLocaleDateString("en-GB")
        : "Start";
    },
    formattedDateTo() {
      return this.dateTo
        ? new Date(this.dateTo).toLocaleDateString("en-GB")
        : "End";
    },
    filteredRecords() {
      let filtered = this.labRecords;
      if (this.dateFrom) {
        filtered = filtered.filter((r) => r.date >= this.dateFrom);
      }
      if (this.dateTo) {
        filtered = filtered.filter((r) => r.date <= this.dateTo);
      }
      return filtered;
    },
    totalTests() {
      return this.filteredRecords.length;
    },
    malariaTests() {
      return this.filteredRecords.filter((r) =>
        r.testRequested.toLowerCase().includes("malaria"),
      ).length;
    },
    hivTests() {
      return this.filteredRecords.filter((r) =>
        r.testRequested.toLowerCase().includes("hiv"),
      ).length;
    },
    positiveResults() {
      return this.filteredRecords.filter(
        (r) =>
          r.result === "Positive" ||
          r.result === "UTI" ||
          (typeof r.result === "string" &&
            r.result.toLowerCase().includes("positive")),
      ).length;
    },
  },
  methods: {
    getResultClass(result) {
      if (result === "Positive" || result === "UTI") {
        return "positive-badge";
      } else if (
        result === "Negative" ||
        result === "Normal" ||
        result === "Non-reactive"
      ) {
        return "negative-badge";
      } else if (
        typeof result === "string" &&
        (result.includes("mmol") || result.includes("g/dL"))
      ) {
        return "value-badge";
      }
      return "default-badge";
    },
    clearDates() {
      this.dateFrom = "";
      this.dateTo = "";
    },
    filterRecords() {
      // Computed property handles filtering
    },
    printPage() {
      window.print();
    },
  },
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.register-container {
  background: white;
  min-height: 100vh;
  padding: 20px;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}

.header {
  text-align: center;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 2px solid #1a56db;
}

.facility-name {
  font-size: 20px;
  font-weight: bold;
  color: #1a56db;
  margin-bottom: 6px;
}

.facility-details {
  font-size: 11px;
  color: #4b5563;
  line-height: 1.4;
  margin-bottom: 10px;
}

.register-title {
  font-size: 14px;
  font-weight: bold;
  background: #f3f4f6;
  display: inline-block;
  padding: 5px 16px;
  border-radius: 20px;
  color: #1f2937;
}

.info-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 16px;
  padding: 12px 16px;
  background: #f9fafb;
  border-radius: 10px;
  border: 1px solid #e5e7eb;
}

.info-left {
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
  align-items: center;
}

.date-range {
  display: flex;
  gap: 12px;
  align-items: center;
  flex-wrap: wrap;
}

.info-item {
  display: flex;
  align-items: center;
  gap: 6px;
}

.info-label {
  font-size: 12px;
  font-weight: 600;
  color: #374151;
}

.info-value {
  font-size: 12px;
  color: #1f2937;
  font-weight: 500;
}

.date-input {
  padding: 5px 8px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 12px;
}

.btn-clear {
  padding: 5px 12px;
  background: #6b7280;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 11px;
  font-weight: 500;
}

.btn-clear:hover {
  background: #4b5563;
}

.btn-print {
  padding: 8px 20px;
  background: #3b82f6;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
}

.btn-print:hover {
  background: #2563eb;
}

.print-date-range {
  text-align: center;
  padding: 8px;
  margin-bottom: 16px;
  background: #fef3c7;
  border-left: 4px solid #f59e0b;
  font-size: 12px;
  color: #92400e;
  border-radius: 6px;
}

.summary-stats {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
  justify-content: center;
  flex-wrap: wrap;
}

.stat-box {
  background: linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%);
  border-radius: 12px;
  padding: 12px 20px;
  text-align: center;
  min-width: 150px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.stat-label {
  display: block;
  font-size: 11px;
  font-weight: 600;
  color: #bfdbfe;
  margin-bottom: 6px;
  text-transform: uppercase;
}

.stat-number {
  display: block;
  font-size: 26px;
  font-weight: bold;
  color: white;
}

.table-wrapper {
  overflow-x: auto;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  max-height: 65vh;
  overflow-y: auto;
}

.lab-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 11px;
  min-width: 1400px;
}

.lab-table th {
  background: #1f2937;
  color: white;
  padding: 10px 6px;
  font-weight: 600;
  text-align: center;
  border: 1px solid #374151;
  position: sticky;
  top: 0;
  z-index: 10;
}

.lab-table td {
  border: 1px solid #d1d5db;
  padding: 8px 6px;
  text-align: left;
}

.lab-table td.text-center {
  text-align: center;
}

.positive-badge {
  background: #fee2e2;
  color: #dc2626;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 10px;
  font-weight: 600;
  display: inline-block;
}

.negative-badge {
  background: #d1fae5;
  color: #059669;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 10px;
  font-weight: 600;
  display: inline-block;
}

.value-badge {
  background: #dbeafe;
  color: #1e40af;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 10px;
  font-weight: 600;
  display: inline-block;
}

.default-badge {
  background: #f3f4f6;
  color: #374151;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 10px;
  font-weight: 500;
  display: inline-block;
}

.empty-row {
  text-align: center;
  padding: 30px;
  color: #6b7280;
}

@media print {
  @page {
    size: landscape;
    margin: 0.3cm;
  }

  .btn-print,
  .btn-clear,
  .date-input {
    display: none;
  }

  .info-bar {
    display: none;
  }

  .print-date-range {
    background: #fef3c7;
    margin: 10px 0;
    padding: 5px;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  .summary-stats {
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  .register-container {
    padding: 0.2cm;
  }

  .header {
    margin-bottom: 5px;
  }

  .facility-name {
    font-size: 14px;
  }

  .facility-details {
    font-size: 8px;
  }

  .register-title {
    font-size: 10px;
  }

  .table-wrapper {
    overflow: visible !important;
    max-height: none;
  }

  .lab-table {
    font-size: 8px;
    min-width: 0 !important;
  }

  .lab-table th {
    padding: 4px 3px;
    font-size: 8px;
    background: #e5e7eb !important;
    color: black !important;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  .lab-table td {
    padding: 4px 3px;
    font-size: 7.5px;
  }
}
</style>
